// extracted by mini-css-extract-plugin
module.exports = {"row":"Coupon_style_row__MxdR3"};